import dashboardReducer from './reducers';

export { default as dashboardActions } from './actions';
export { default as dashboardOperations } from './operations';
export { default as dashboardShapes } from './shapes';

export default dashboardReducer;
